import {
    CONTENT_LANGUAGE_CHANGE_ACTION
} from '../constants/Types';

export const changeContentLanguage = (language) => ({type: CONTENT_LANGUAGE_CHANGE_ACTION, language});
